import type { IClaims } from '@/interfaces'

export class Claims implements IClaims {
	[key: string]: unknown
	iss?: string
	sub?: string
	aud?: string[] | string
	exp?: number
	nbf?: number
	iat?: number
	jti?: string
	roles: string[]
	salesGroup: string[]

	constructor({ iss, sub, aud, exp, nbf, iat, jti, roles = [], salesGroup = [] }: Partial<IClaims> = {}) {
		this.iss = iss
		this.sub = sub
		this.aud = aud
		this.exp = exp
		this.nbf = nbf
		this.iat = iat
		this.jti = jti
		this.roles = roles
		if (typeof salesGroup === 'string') {
			this.salesGroup = [salesGroup]
		} else {
			this.salesGroup = salesGroup
		}
	}
}
